import Modal from "@module/_core/app/component/Modal";
import { forwardRef, useImperativeHandle, useState } from "react";
import HistoryPayment from "../HistoryPayment";

interface HistoryPaymentModalHandler {
    open: () => void;
}

const HistoryPaymentModal = forwardRef<HistoryPaymentModalHandler>((_, ref) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    useImperativeHandle(ref, () => ({
        open: () => setIsModalOpen(true)
    }));

    const onClose = () => setIsModalOpen(false);

    return (
        <Modal open={isModalOpen} className="w-[488px] mx-4 p-4! tab:p-0!" onClose={onClose}>
            <HistoryPayment onBack={onClose} />
        </Modal>
    );
});

export default HistoryPaymentModal;
